AccessController = App.loadClass 'admin::Angular/AccessController'

class exports.BushelsController extends AccessController
    # This is the only time you ever want to use a skinny arrow. Every other function call should use a fat arrow.
    constructor: (@scope, @transitions, @modal, @bushelsService, @q, @http) ->
        super('bushels', @http)

        # Must use the $q service to utilize promises correctly.
        @scope.fullpage = true
        @scope.title = 'Bushels'

        # Give the content for my info icon
        @scope.tooltipContent = '<div>
            <p>This tool attempts to estimate the number of bushels MyFarms has increased the world food supply.
                It looks at the acreage of planting plans and records generated from an SPP,
                multiplied by the estimated bushels/acre increase from our recommendations.
            </p>
            <p>The last research we had from Burrus showed a 12.5
            bushel per acre increase, which is the default.
            </p></div>'

        # Preload the HTML element with the ng-model attribute
        # with value of "bushelsIncrease" with a value of 12.5
        @scope.bushelsIncrease = 12.5

        # Get the data
        @getData()

        # When the button with the ng-click attribute
        # with value "updateGraph" is clicked,
        # run the getData function
        @scope.updateGraph = () =>
            @getData()

    save: () =>
        @getData()

    getData: () =>
        # Run the getBushelsByYear function
        # (passing in the bushelsIncrease value)
        # in the BushelsService.coffee service,
        # which then calls the route in the Bushels.php controller,
        # returning the query result to the scope
        # (which the view can use) as "bushelsByYear".

        # Once the data is returned, run parseYearBushelData.
        # Note that the loadScopeData function is predefined
        # in the core Angular controller.

        @loadScopeData(@bushelsService.getBushelsByYear(@scope.bushelsIncrease), 'bushelsByYear')
        .then () => @parseYearBushelData()

    # Parse the bushelsByYear array of objects into separate arrays
    # in order to match the required data format for chart.js.
    # These arrays can be referenced in the view by the
    # variables we've made available to the scope (years, bushels, and series)
    parseYearBushelData: () =>

        @scope.years = (dataobject.year for dataobject in @scope.bushelsByYear.bushelsYearPlan)
        @scope.bushels = [
            parseFloat(dataobject.bushels) for dataobject in @scope.bushelsByYear.bushelsYearPlan,
            parseFloat(dataobject.bushels) for dataobject in @scope.bushelsByYear.bushelsYearActual
        ]
        @scope.series = ['Plan Bushels Increased (millions)', 'Record Bushels Increased (millions)']
        # console.log(@scope.years)
        # console.log(@scope.bushels)
        # console.log(@scope.series)

    # ******************** OTHER NOTES *****************************
    # Prepending crap with "@scope" makes it available within the scope.
    # Need to use "this." to reference the current object (the class instance in this case).
    # CoffeeScript abbreviates this to "@".
    #parseInt() casts to int
    #parseFloat() casts to float
    #.toLocaleString() will implement default locale formatting with commas.

